/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or
 * distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly
 * prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this
 * content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import clsx from 'clsx'
import { FieldErrors } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import UiFormLabel from 'components/Ui/UiFormLabel'

interface CompanyFormLabelProps {
    errors: FieldErrors
    name: string
    required?: boolean
    label: React.ReactNode
    className?: string
}

const CompanyFormLabel = (props: CompanyFormLabelProps) => {
    const { t } = useTranslation()
    return (
        <UiFormLabel
            htmlFor={'input-' + props.name}
            data-testid={'label-' + props.name}
            className={clsx('mb-1.5 flex', props.className, props.errors?.[props.name] && 'text-red-500')}
            isRequired={props.required === true}
        >
            {typeof props.label === 'string' ? t(props.label) : props.label}
        </UiFormLabel>
    )
}

export default CompanyFormLabel
